import {gql} from '@apollo/client';

export default gql`
    mutation renewAuthToken ($expire_after: Int) {
      renewAuthToken (expire_after: $expire_after)
    }
`;
